// localStorage keys shared between the mock services and the e2e suite that drives them.
// Angular-free on purpose so e2e can import it without pulling in the Angular barrel.

export const MOCK_CHILDREN_SCENARIO_KEY: Readonly<string> = 'my_group_children_scenario';
export const MOCK_CHILDREN_DELETE_KEY: Readonly<string> = 'my_group_children_delete';
export const MOCK_CHILDREN_CREATE_KEY: Readonly<string> = 'my_group_children_create';
export const MOCK_CHILDREN_HIDE_KEY: Readonly<string> = 'my_group_children_hide';
export const MOCK_CHILDREN_REPORT_KEY: Readonly<string> = 'my_group_children_report';
export const MOCK_CHILDREN_LOAD_KEY: Readonly<string> = 'my_group_children_load';
export const MOCK_CHILDREN_DELAY_KEY: Readonly<string> = 'my_group_children_delay';

export const MOCK_DASHBOARD_SCENARIO_KEY: Readonly<string> = 'my_group_dashboard_scenario';
export const MOCK_DASHBOARD_LOAD_KEY: Readonly<string> = 'my_group_dashboard_load';
export const MOCK_DASHBOARD_DELAY_KEY: Readonly<string> = 'my_group_dashboard_delay';
